/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as KeresesRouteImport } from './routes/kereses';
import { Route as KukaRouteImport } from './routes/kuka';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ProfilRouteImport } from './routes/profil';
import { Route as SablonokRouteImport } from './routes/sablonok';
import { Route as SzerkezetRouteImport } from './routes/szerkezet';
import { Route as TudastarRouteImport } from './routes/tudastar';
import { Route as UjCikkRouteImport } from './routes/uj-cikk';
import { Route as UzemeltetesRouteImport } from './routes/uzemeltetes';
import { Route as SugoIndexRouteImport } from './routes/sugo/index';
import { Route as SzerkesztesArticleIdRouteImport } from './routes/szerkesztes/$articleId';
import { Route as TagTagRouteImport } from './routes/tag/$tag';
import { Route as ValtozatokArticleIdRouteImport } from './routes/valtozatok/$articleId';
import { Route as HubSpaceSlugIndexRouteImport } from './routes/hub/$spaceSlug/index';
import { Route as SugoSpaceSlugIndexRouteImport } from './routes/sugo/$spaceSlug/index';
import { Route as HubSpaceSlugCategorySlugIndexRouteImport } from './routes/hub/$spaceSlug/$categorySlug/index';
import { Route as HubSpaceSlugCategorySlugArticleSlugRouteImport } from './routes/hub/$spaceSlug/$categorySlug/$articleSlug';
import { Route as SugoSpaceSlugCategorySlugArticleSlugRouteImport } from './routes/sugo/$spaceSlug/$categorySlug/$articleSlug';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const KeresesRoute = KeresesRouteImport.update({
  id: '/kereses',
  path: '/kereses',
  getParentRoute: () => rootRouteImport,
} as any);
const KukaRoute = KukaRouteImport.update({
  id: '/kuka',
  path: '/kuka',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ProfilRoute = ProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => rootRouteImport,
} as any);
const SablonokRoute = SablonokRouteImport.update({
  id: '/sablonok',
  path: '/sablonok',
  getParentRoute: () => rootRouteImport,
} as any);
const SzerkezetRoute = SzerkezetRouteImport.update({
  id: '/szerkezet',
  path: '/szerkezet',
  getParentRoute: () => rootRouteImport,
} as any);
const TudastarRoute = TudastarRouteImport.update({
  id: '/tudastar',
  path: '/tudastar',
  getParentRoute: () => rootRouteImport,
} as any);
const UjCikkRoute = UjCikkRouteImport.update({
  id: '/uj-cikk',
  path: '/uj-cikk',
  getParentRoute: () => rootRouteImport,
} as any);
const UzemeltetesRoute = UzemeltetesRouteImport.update({
  id: '/uzemeltetes',
  path: '/uzemeltetes',
  getParentRoute: () => rootRouteImport,
} as any);
const SugoIndexRoute = SugoIndexRouteImport.update({
  id: '/sugo/',
  path: '/sugo/',
  getParentRoute: () => rootRouteImport,
} as any);
const SzerkesztesArticleIdRoute = SzerkesztesArticleIdRouteImport.update({
  id: '/szerkesztes/$articleId',
  path: '/szerkesztes/$articleId',
  getParentRoute: () => rootRouteImport,
} as any);
const TagTagRoute = TagTagRouteImport.update({
  id: '/tag/$tag',
  path: '/tag/$tag',
  getParentRoute: () => rootRouteImport,
} as any);
const ValtozatokArticleIdRoute = ValtozatokArticleIdRouteImport.update({
  id: '/valtozatok/$articleId',
  path: '/valtozatok/$articleId',
  getParentRoute: () => rootRouteImport,
} as any);
const HubSpaceSlugIndexRoute = HubSpaceSlugIndexRouteImport.update({
  id: '/hub/$spaceSlug/',
  path: '/hub/$spaceSlug/',
  getParentRoute: () => rootRouteImport,
} as any);
const SugoSpaceSlugIndexRoute = SugoSpaceSlugIndexRouteImport.update({
  id: '/sugo/$spaceSlug/',
  path: '/sugo/$spaceSlug/',
  getParentRoute: () => rootRouteImport,
} as any);
const HubSpaceSlugCategorySlugIndexRoute =
  HubSpaceSlugCategorySlugIndexRouteImport.update({
    id: '/hub/$spaceSlug/$categorySlug/',
    path: '/hub/$spaceSlug/$categorySlug/',
    getParentRoute: () => rootRouteImport,
  } as any);
const HubSpaceSlugCategorySlugArticleSlugRoute =
  HubSpaceSlugCategorySlugArticleSlugRouteImport.update({
    id: '/hub/$spaceSlug/$categorySlug/$articleSlug',
    path: '/hub/$spaceSlug/$categorySlug/$articleSlug',
    getParentRoute: () => rootRouteImport,
  } as any);
const SugoSpaceSlugCategorySlugArticleSlugRoute =
  SugoSpaceSlugCategorySlugArticleSlugRouteImport.update({
    id: '/sugo/$spaceSlug/$categorySlug/$articleSlug',
    path: '/sugo/$spaceSlug/$categorySlug/$articleSlug',
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/kereses': typeof KeresesRoute;
  '/kuka': typeof KukaRoute;
  '/login': typeof LoginRoute;
  '/profil': typeof ProfilRoute;
  '/sablonok': typeof SablonokRoute;
  '/szerkezet': typeof SzerkezetRoute;
  '/tudastar': typeof TudastarRoute;
  '/uj-cikk': typeof UjCikkRoute;
  '/uzemeltetes': typeof UzemeltetesRoute;
  '/szerkesztes/$articleId': typeof SzerkesztesArticleIdRoute;
  '/tag/$tag': typeof TagTagRoute;
  '/valtozatok/$articleId': typeof ValtozatokArticleIdRoute;
  '/sugo/': typeof SugoIndexRoute;
  '/hub/$spaceSlug/': typeof HubSpaceSlugIndexRoute;
  '/sugo/$spaceSlug/': typeof SugoSpaceSlugIndexRoute;
  '/hub/$spaceSlug/$categorySlug/$articleSlug': typeof HubSpaceSlugCategorySlugArticleSlugRoute;
  '/sugo/$spaceSlug/$categorySlug/$articleSlug': typeof SugoSpaceSlugCategorySlugArticleSlugRoute;
  '/hub/$spaceSlug/$categorySlug/': typeof HubSpaceSlugCategorySlugIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/kereses': typeof KeresesRoute;
  '/kuka': typeof KukaRoute;
  '/login': typeof LoginRoute;
  '/profil': typeof ProfilRoute;
  '/sablonok': typeof SablonokRoute;
  '/szerkezet': typeof SzerkezetRoute;
  '/tudastar': typeof TudastarRoute;
  '/uj-cikk': typeof UjCikkRoute;
  '/uzemeltetes': typeof UzemeltetesRoute;
  '/szerkesztes/$articleId': typeof SzerkesztesArticleIdRoute;
  '/tag/$tag': typeof TagTagRoute;
  '/valtozatok/$articleId': typeof ValtozatokArticleIdRoute;
  '/sugo': typeof SugoIndexRoute;
  '/hub/$spaceSlug': typeof HubSpaceSlugIndexRoute;
  '/sugo/$spaceSlug': typeof SugoSpaceSlugIndexRoute;
  '/hub/$spaceSlug/$categorySlug/$articleSlug': typeof HubSpaceSlugCategorySlugArticleSlugRoute;
  '/sugo/$spaceSlug/$categorySlug/$articleSlug': typeof SugoSpaceSlugCategorySlugArticleSlugRoute;
  '/hub/$spaceSlug/$categorySlug': typeof HubSpaceSlugCategorySlugIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/kereses': typeof KeresesRoute;
  '/kuka': typeof KukaRoute;
  '/login': typeof LoginRoute;
  '/profil': typeof ProfilRoute;
  '/sablonok': typeof SablonokRoute;
  '/szerkezet': typeof SzerkezetRoute;
  '/tudastar': typeof TudastarRoute;
  '/uj-cikk': typeof UjCikkRoute;
  '/uzemeltetes': typeof UzemeltetesRoute;
  '/szerkesztes/$articleId': typeof SzerkesztesArticleIdRoute;
  '/tag/$tag': typeof TagTagRoute;
  '/valtozatok/$articleId': typeof ValtozatokArticleIdRoute;
  '/sugo/': typeof SugoIndexRoute;
  '/hub/$spaceSlug/': typeof HubSpaceSlugIndexRoute;
  '/sugo/$spaceSlug/': typeof SugoSpaceSlugIndexRoute;
  '/hub/$spaceSlug/$categorySlug/$articleSlug': typeof HubSpaceSlugCategorySlugArticleSlugRoute;
  '/sugo/$spaceSlug/$categorySlug/$articleSlug': typeof SugoSpaceSlugCategorySlugArticleSlugRoute;
  '/hub/$spaceSlug/$categorySlug/': typeof HubSpaceSlugCategorySlugIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/kereses'
    | '/kuka'
    | '/login'
    | '/profil'
    | '/sablonok'
    | '/szerkezet'
    | '/tudastar'
    | '/uj-cikk'
    | '/uzemeltetes'
    | '/szerkesztes/$articleId'
    | '/tag/$tag'
    | '/valtozatok/$articleId'
    | '/sugo/'
    | '/hub/$spaceSlug/'
    | '/sugo/$spaceSlug/'
    | '/hub/$spaceSlug/$categorySlug/$articleSlug'
    | '/sugo/$spaceSlug/$categorySlug/$articleSlug'
    | '/hub/$spaceSlug/$categorySlug/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/kereses'
    | '/kuka'
    | '/login'
    | '/profil'
    | '/sablonok'
    | '/szerkezet'
    | '/tudastar'
    | '/uj-cikk'
    | '/uzemeltetes'
    | '/szerkesztes/$articleId'
    | '/tag/$tag'
    | '/valtozatok/$articleId'
    | '/sugo'
    | '/hub/$spaceSlug'
    | '/sugo/$spaceSlug'
    | '/hub/$spaceSlug/$categorySlug/$articleSlug'
    | '/sugo/$spaceSlug/$categorySlug/$articleSlug'
    | '/hub/$spaceSlug/$categorySlug';
  id:
    | '__root__'
    | '/'
    | '/kereses'
    | '/kuka'
    | '/login'
    | '/profil'
    | '/sablonok'
    | '/szerkezet'
    | '/tudastar'
    | '/uj-cikk'
    | '/uzemeltetes'
    | '/szerkesztes/$articleId'
    | '/tag/$tag'
    | '/valtozatok/$articleId'
    | '/sugo/'
    | '/hub/$spaceSlug/'
    | '/sugo/$spaceSlug/'
    | '/hub/$spaceSlug/$categorySlug/$articleSlug'
    | '/sugo/$spaceSlug/$categorySlug/$articleSlug'
    | '/hub/$spaceSlug/$categorySlug/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  KeresesRoute: typeof KeresesRoute;
  KukaRoute: typeof KukaRoute;
  LoginRoute: typeof LoginRoute;
  ProfilRoute: typeof ProfilRoute;
  SablonokRoute: typeof SablonokRoute;
  SzerkezetRoute: typeof SzerkezetRoute;
  TudastarRoute: typeof TudastarRoute;
  UjCikkRoute: typeof UjCikkRoute;
  UzemeltetesRoute: typeof UzemeltetesRoute;
  SzerkesztesArticleIdRoute: typeof SzerkesztesArticleIdRoute;
  TagTagRoute: typeof TagTagRoute;
  ValtozatokArticleIdRoute: typeof ValtozatokArticleIdRoute;
  SugoIndexRoute: typeof SugoIndexRoute;
  HubSpaceSlugIndexRoute: typeof HubSpaceSlugIndexRoute;
  SugoSpaceSlugIndexRoute: typeof SugoSpaceSlugIndexRoute;
  HubSpaceSlugCategorySlugArticleSlugRoute: typeof HubSpaceSlugCategorySlugArticleSlugRoute;
  SugoSpaceSlugCategorySlugArticleSlugRoute: typeof SugoSpaceSlugCategorySlugArticleSlugRoute;
  HubSpaceSlugCategorySlugIndexRoute: typeof HubSpaceSlugCategorySlugIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/kereses': {
      id: '/kereses';
      path: '/kereses';
      fullPath: '/kereses';
      preLoaderRoute: typeof KeresesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/kuka': {
      id: '/kuka';
      path: '/kuka';
      fullPath: '/kuka';
      preLoaderRoute: typeof KukaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/profil': {
      id: '/profil';
      path: '/profil';
      fullPath: '/profil';
      preLoaderRoute: typeof ProfilRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sablonok': {
      id: '/sablonok';
      path: '/sablonok';
      fullPath: '/sablonok';
      preLoaderRoute: typeof SablonokRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/szerkezet': {
      id: '/szerkezet';
      path: '/szerkezet';
      fullPath: '/szerkezet';
      preLoaderRoute: typeof SzerkezetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tudastar': {
      id: '/tudastar';
      path: '/tudastar';
      fullPath: '/tudastar';
      preLoaderRoute: typeof TudastarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/uj-cikk': {
      id: '/uj-cikk';
      path: '/uj-cikk';
      fullPath: '/uj-cikk';
      preLoaderRoute: typeof UjCikkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/uzemeltetes': {
      id: '/uzemeltetes';
      path: '/uzemeltetes';
      fullPath: '/uzemeltetes';
      preLoaderRoute: typeof UzemeltetesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sugo/': {
      id: '/sugo/';
      path: '/sugo';
      fullPath: '/sugo/';
      preLoaderRoute: typeof SugoIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/szerkesztes/$articleId': {
      id: '/szerkesztes/$articleId';
      path: '/szerkesztes/$articleId';
      fullPath: '/szerkesztes/$articleId';
      preLoaderRoute: typeof SzerkesztesArticleIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tag/$tag': {
      id: '/tag/$tag';
      path: '/tag/$tag';
      fullPath: '/tag/$tag';
      preLoaderRoute: typeof TagTagRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/valtozatok/$articleId': {
      id: '/valtozatok/$articleId';
      path: '/valtozatok/$articleId';
      fullPath: '/valtozatok/$articleId';
      preLoaderRoute: typeof ValtozatokArticleIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/hub/$spaceSlug/': {
      id: '/hub/$spaceSlug/';
      path: '/hub/$spaceSlug';
      fullPath: '/hub/$spaceSlug/';
      preLoaderRoute: typeof HubSpaceSlugIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sugo/$spaceSlug/': {
      id: '/sugo/$spaceSlug/';
      path: '/sugo/$spaceSlug';
      fullPath: '/sugo/$spaceSlug/';
      preLoaderRoute: typeof SugoSpaceSlugIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/hub/$spaceSlug/$categorySlug/': {
      id: '/hub/$spaceSlug/$categorySlug/';
      path: '/hub/$spaceSlug/$categorySlug';
      fullPath: '/hub/$spaceSlug/$categorySlug/';
      preLoaderRoute: typeof HubSpaceSlugCategorySlugIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/hub/$spaceSlug/$categorySlug/$articleSlug': {
      id: '/hub/$spaceSlug/$categorySlug/$articleSlug';
      path: '/hub/$spaceSlug/$categorySlug/$articleSlug';
      fullPath: '/hub/$spaceSlug/$categorySlug/$articleSlug';
      preLoaderRoute: typeof HubSpaceSlugCategorySlugArticleSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sugo/$spaceSlug/$categorySlug/$articleSlug': {
      id: '/sugo/$spaceSlug/$categorySlug/$articleSlug';
      path: '/sugo/$spaceSlug/$categorySlug/$articleSlug';
      fullPath: '/sugo/$spaceSlug/$categorySlug/$articleSlug';
      preLoaderRoute: typeof SugoSpaceSlugCategorySlugArticleSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KeresesRoute: KeresesRoute,
  KukaRoute: KukaRoute,
  LoginRoute: LoginRoute,
  ProfilRoute: ProfilRoute,
  SablonokRoute: SablonokRoute,
  SzerkezetRoute: SzerkezetRoute,
  TudastarRoute: TudastarRoute,
  UjCikkRoute: UjCikkRoute,
  UzemeltetesRoute: UzemeltetesRoute,
  SzerkesztesArticleIdRoute: SzerkesztesArticleIdRoute,
  TagTagRoute: TagTagRoute,
  ValtozatokArticleIdRoute: ValtozatokArticleIdRoute,
  SugoIndexRoute: SugoIndexRoute,
  HubSpaceSlugIndexRoute: HubSpaceSlugIndexRoute,
  SugoSpaceSlugIndexRoute: SugoSpaceSlugIndexRoute,
  HubSpaceSlugCategorySlugArticleSlugRoute:
    HubSpaceSlugCategorySlugArticleSlugRoute,
  SugoSpaceSlugCategorySlugArticleSlugRoute:
    SugoSpaceSlugCategorySlugArticleSlugRoute,
  HubSpaceSlugCategorySlugIndexRoute: HubSpaceSlugCategorySlugIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
